import { AllyBase } from "../base";
import { AllyFunctionMatrix } from "../ally-function-matrix.class";
import { AllyId } from "../ally-id.class";
import { AllyObject } from "../ally-object.class";

/**
 * The base class for all classes in ../elements.
 * 
 * @extends AllyBase
 */
export class AllyElementBase extends AllyBase {
    /**
     * All extending classes save their created callbacks in this dictionary.
     * 
     * Their order determines in which order they are applied.
     */
    private static loadorder: {[index: number]: AllyElementBase["callback"]} = {};
    /**
     * The callback to be provided by the extending class.
     * 
     * The callbacks for the functions matrix will be created in this callback.
     */
    private callback: (matrix: AllyFunctionMatrix<AllyObject["scope"]>["matrix"]) => void;
    /**
     * The AllyId object for the AllyElementBase class.
     * @see AllyId
     */
    private static id: AllyId = new AllyId("element", AllyBase.bridge);
    /**
     * The id of this AllyElementBase object.
     */
    protected id: string;
    
    /**
     * @param bridge The bridge to the parent in the hierarchical tree.
     * @param callback
     * The callback to be provided by the extending class.
     * 
     * The callbacks for the functions matrix will be created in this callback.
     * @param index The index for the loadorder.
     */
    constructor(bridge: () => AllyBase, callback: (matrix: AllyFunctionMatrix<AllyObject["scope"]>["matrix"]) => void, index: number) {
        super(bridge);
        this.callback = callback;
        this.id = AllyElementBase.id.getId();
        this.destroyer.addCallback(() => {
            AllyElementBase.id.returnId(this.id);
        });
        if (!(index in AllyElementBase.loadorder)) {
            AllyElementBase.loadorder[index] = this.callback;
        } else {
            throw new Error("index already in loadorder");
        }
    }

    /**
     * Writes the callbacks defined by the extending classes of the class AllyElementBase into the provided function matrix.
     * @param matrix The function matrix to be provided.
     */
    public static init(matrix: AllyFunctionMatrix<AllyObject["scope"]>["matrix"]) {
        let i = 0;
        while (i in AllyElementBase.loadorder) {
            AllyElementBase.loadorder[i](matrix);
            i++
        }
    }
}